/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Err_Already_MsgInputs */

const es_cap_err_already_msg = /** @type {(inputs: Cap_Err_Already_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta ya tiene un perfil de capitán.`)
};

const gl_cap_err_already_msg = /** @type {(inputs: Cap_Err_Already_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A túa conta xa ten un perfil de patrón.`)
};

const en_cap_err_already_msg = /** @type {(inputs: Cap_Err_Already_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account already has a skipper profile.`)
};

/**
* | output |
* | --- |
* | "Your account already has a skipper profile." |
*
* @param {Cap_Err_Already_MsgInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_err_already_msg = /** @type {((inputs?: Cap_Err_Already_MsgInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Err_Already_MsgInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_err_already_msg(inputs)
	if (locale === "en") return en_cap_err_already_msg(inputs)
	return es_cap_err_already_msg(inputs)
});